// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "." + {"440":"5ee9f9a27bc92c7c49fb","581":"b99d8260cd64ae7a3653"}[chunkId] + ".js";
};